export default __webpack_public_path__ + "static/media/MOLECULAR MIKROO.2b53c313.jpg";